import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { UserRoles } from '../../util/constants/common.constants';
import { Menu } from '@material-ui/core';

export function UserPermission({ user }: any) {
  
  let role: any = [];
  user?.idTokenClaims?.roles?.map((item: any) => {
    role.push(item);
  });
  
  const [currentUserRole, setCurrentUserRole] =  React.useState<any>(localStorage.getItem("userRole"));
  const handleChange = (event: SelectChangeEvent) => {
    localStorage.removeItem("userRole");
    localStorage.setItem("userRole", event.target.value);
    window.location.reload();
  };
  return (
      <Box sx={{ minWidth: 120, width: 200 }} className="main-select-box">
          <FormControl fullWidth className="label-text">
              <InputLabel  id="demo-simple-select-label">Select User Role</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={currentUserRole}
          label="User Role"
          onChange={handleChange}
        >        
         
          <MenuItem value={UserRoles.ICD10_OD}>{UserRoles.ICD10_OD}</MenuItem>
          <MenuItem value={UserRoles.ICD10_GM}>{UserRoles.ICD10_GM}</MenuItem>
          <MenuItem value={UserRoles.ICD10_CCT}>{UserRoles.ICD10_CCT}</MenuItem>
          <MenuItem value={UserRoles.ICD10_CM}>{UserRoles.ICD10_CM}</MenuItem>
          <MenuItem value={UserRoles.ICD10_OTHER}>{UserRoles.ICD10_OTHER}</MenuItem>
          <MenuItem value={UserRoles.ICD10_DM}>{UserRoles.ICD10_DM}</MenuItem>
           <MenuItem value={UserRoles.ICD10_CEC}>{UserRoles.ICD10_CEC}</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};
